var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftballLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 329 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-132);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-118);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-136);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-145);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-142);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-87 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-106);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-138);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-116);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-113);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient-122);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-146);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-125);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-107 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-143);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-107);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-112 {\n        fill: url(#linear-gradient-144);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-129);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-133);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-109);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-116 {\n        isolation: isolate;\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-147);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-110);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-120 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-131);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-102);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-122 {\n        fill: url(#linear-gradient-135);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-121);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-124 {\n        fill: url(#linear-gradient-124);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-126 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-139);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-128 {\n        fill: url(#linear-gradient-148);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-141);\n      }\n\n      .cls-130 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-134);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-132 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-133 {\n        fill: url(#linear-gradient-120);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-100);\n      }\n\n      .cls-134 {\n        fill: url(#linear-gradient-112);\n      }\n\n      .cls-135 {\n        fill: #201612;\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-136 {\n        fill: url(#linear-gradient-137);\n      }\n\n      .cls-137 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-138 {\n        fill: url(#linear-gradient-119);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-140 {\n        fill: url(#linear-gradient-127);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-105);\n      }\n\n      .cls-141 {\n        fill: url(#linear-gradient-114);\n      }\n\n      .cls-142 {\n        fill: url(#linear-gradient-140);\n      }\n\n      .cls-143 {\n        fill: url(#linear-gradient-117);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-128);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-108);\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-146 {\n        fill: url(#linear-gradient-130);\n      }\n\n      .cls-147 {\n        fill: url(#linear-gradient-111);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-148 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-149 {\n        fill: url(#linear-gradient-115);\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-126);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-151 {\n        fill: url(#linear-gradient-123);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-7);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1798.66,
    cy: 214.18,
    fx: 1798.66,
    fy: 214.18,
    r: 165.54,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d4df43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#c3cf3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90a73c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1677.22,
    y1: 158.48,
    x2: 1679.88,
    y2: 158.48,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a28889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#774c43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1678.97,
    y1: 162.71,
    x2: 1681.69,
    y2: 162.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1700.87,
    y1: 137.17,
    x2: 1700.87,
    y2: 368.84,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1688.54,
    y1: 322.66,
    x2: 1696.77,
    y2: 322.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1703.64,
    y1: 137.38,
    x2: 1707.08,
    y2: 135.14,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f5e50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aca299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1706.07,
    y1: 138.79,
    x2: 1710.47,
    y2: 138.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1713.57,
    y1: 169.27,
    x2: 1720.13,
    y2: 169.27,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1719.35,
    y1: 185.44,
    x2: 1726.69,
    y2: 182.66,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1711.18,
    y1: 154.36,
    x2: 1718.12,
    y2: 154.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1719.18,
    y1: 366.89,
    x2: 1724.29,
    y2: 364.96,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1715.88,
    y1: 378.61,
    x2: 1720.97,
    y2: 376.69,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1713.85,
    y1: 384.87,
    x2: 1718.25,
    y2: 383.2,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1725.57,
    y1: 336.5,
    x2: 1731.93,
    y2: 334.1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1723.56,
    y1: 354.28,
    x2: 1729.33,
    y2: 352.1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1721.35,
    y1: 205.67,
    x2: 1729.92,
    y2: 202.43,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1726.02,
    y1: 225.57,
    x2: 1733.09,
    y2: 222.9,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1726.76,
    y1: 249.55,
    x2: 1735.02,
    y2: 246.43,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1729.84,
    y1: 274.01,
    x2: 1736.34,
    y2: 271.55,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1729.65,
    y1: 296.37,
    x2: 1736.94,
    y2: 293.61,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1727.37,
    y1: 317.46,
    x2: 1734.15,
    y2: 314.9,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1683.07,
    y1: 359.81,
    x2: 1686.99,
    y2: 359.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1681.96,
    y1: 362.39,
    x2: 1685.18,
    y2: 362.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1684.46,
    y1: 353.92,
    x2: 1688.55,
    y2: 353.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1685.7,
    y1: 346.64,
    x2: 1691.85,
    y2: 346.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1688.4,
    y1: 335.34,
    x2: 1693.5,
    y2: 335.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1688.54,
    y1: 308.55,
    x2: 1695.75,
    y2: 308.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1689.16,
    y1: 289.6,
    x2: 1696.16,
    y2: 289.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1688.11,
    y1: 271.28,
    x2: 1694.44,
    y2: 271.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1687.46,
    y1: 254.21,
    x2: 1693.7,
    y2: 254.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1686.91,
    y1: 237.87,
    x2: 1692.36,
    y2: 237.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1685.83,
    y1: 219.75,
    x2: 1691.22,
    y2: 219.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1683.94,
    y1: 205.27,
    x2: 1689.59,
    y2: 205.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1680.78,
    y1: 192.22,
    x2: 1685.18,
    y2: 192.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1678.93,
    y1: 180.88,
    x2: 1683.22,
    y2: 180.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1676.87,
    y1: 171.62,
    x2: 1681.1,
    y2: 171.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1684.22,
    y1: 369.31,
    x2: 1698.04,
    y2: 369.31,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1681.92,
    y1: 370.88,
    x2: 1690.89,
    y2: 370.88,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1687.05,
    y1: 362.34,
    x2: 1697.83,
    y2: 370.29,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1687.55,
    y1: 356.05,
    x2: 1698.81,
    y2: 362.9,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1686.88,
    y1: 347.31,
    x2: 1701.56,
    y2: 353.18,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c06373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1691.65,
    y1: 335.84,
    x2: 1703.08,
    y2: 340.09,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1692.76,
    y1: 321.68,
    x2: 1706.34,
    y2: 323.48,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1693.58,
    y1: 308.61,
    x2: 1708.76,
    y2: 305.18,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1693.58,
    y1: 290.34,
    x2: 1711.17,
    y2: 284.48,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1690.96,
    y1: 272.15,
    x2: 1708.84,
    y2: 263.95,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1690.52,
    y1: 252.84,
    x2: 1705.21,
    y2: 241.91,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1691.28,
    y1: 233.13,
    x2: 1703.95,
    y2: 222.61,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1688.93,
    y1: 215.61,
    x2: 1703.99,
    y2: 202.33,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1687.03,
    y1: 202.29,
    x2: 1702.04,
    y2: 186.46,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1684.83,
    y1: 185.2,
    x2: 1698.89,
    y2: 174.58,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1681.21,
    y1: 176.14,
    x2: 1694.27,
    y2: 163.57,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1678.86,
    y1: 161.75,
    x2: 1689.96,
    y2: 150.65,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1678.48,
    y1: 156.39,
    x2: 1689.08,
    y2: 147.09,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1708.68,
    y1: 145.14,
    x2: 1715.37,
    y2: 145.14,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1709.52,
    y1: 387.26,
    x2: 1713.91,
    y2: 385.6,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1702.3,
    y1: 190.71,
    x2: 1716.87,
    y2: 184.85,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c06373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9d3b44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#963740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#8a3138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#79292d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#631e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1695.11,
    y1: 165.86,
    x2: 1710.46,
    y2: 157.21,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1693.31,
    y1: 155.48,
    x2: 1709.63,
    y2: 145.37,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1699.15,
    y1: 175.39,
    x2: 1714.51,
    y2: 168.13,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1705.22,
    y1: 205.01,
    x2: 1723.66,
    y2: 206.32,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1707.09,
    y1: 224.62,
    x2: 1725.69,
    y2: 226.09,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1709.27,
    y1: 245.3,
    x2: 1726.67,
    y2: 249.32,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1710.37,
    y1: 269.31,
    x2: 1730.44,
    y2: 274.37,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1710.94,
    y1: 290.64,
    x2: 1729.05,
    y2: 295.67,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1710.18,
    y1: 310.18,
    x2: 1728.16,
    y2: 317.7,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1710.29,
    y1: 329.19,
    x2: 1725.85,
    y2: 336.56,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c06373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6c2225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1708.15,
    y1: 343.18,
    x2: 1722.67,
    y2: 353.13,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1705.84,
    y1: 357.07,
    x2: 1717.9,
    y2: 366.16,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6c2225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1703.05,
    y1: 367.44,
    x2: 1713.33,
    y2: 374.78,
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1699.51,
    y1: 373.78,
    x2: 1710.96,
    y2: 382.49,
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1698.88,
    y1: 377.72,
    x2: 1707.09,
    y2: 384.19,
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1691.65,
    y1: 148.53,
    x2: 1706.83,
    y2: 139.06,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1691.33,
    y1: 143.51,
    x2: 1702.96,
    y2: 135.97,
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1679.63,
    y1: 167.66,
    x2: 1690.88,
    y2: 156.08,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 29.69,
    y1: 369.79,
    x2: 39.91,
    y2: 369.79,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 24.98,
    y1: 158.48,
    x2: 27.64,
    y2: 158.48,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 26.73,
    y1: 162.71,
    x2: 29.44,
    y2: 162.71,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1891.81,
    y1: 137.18,
    x2: 1891.81,
    y2: 367.94,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 36.3,
    y1: 322.66,
    x2: 44.52,
    y2: 322.66,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 51.39,
    y1: 137.38,
    x2: 54.84,
    y2: 135.14,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 53.82,
    y1: 138.79,
    x2: 58.23,
    y2: 138.79,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 61.33,
    y1: 169.27,
    x2: 67.89,
    y2: 169.27,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 67.1,
    y1: 185.44,
    x2: 74.45,
    y2: 182.66,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 58.94,
    y1: 154.36,
    x2: 65.88,
    y2: 154.36,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 66.94,
    y1: 366.89,
    x2: 72.04,
    y2: 364.96,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 63.63,
    y1: 378.61,
    x2: 68.72,
    y2: 376.69,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 61.61,
    y1: 384.87,
    x2: 66.01,
    y2: 383.2,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 73.32,
    y1: 336.5,
    x2: 79.69,
    y2: 334.1,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 71.32,
    y1: 354.28,
    x2: 77.09,
    y2: 352.1,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 69.1,
    y1: 205.67,
    x2: 77.67,
    y2: 202.43,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 73.78,
    y1: 225.57,
    x2: 80.84,
    y2: 222.9,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 74.51,
    y1: 249.55,
    x2: 82.77,
    y2: 246.43,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 77.6,
    y1: 274.01,
    x2: 84.09,
    y2: 271.55,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 77.41,
    y1: 296.37,
    x2: 84.7,
    y2: 293.61,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 75.12,
    y1: 317.46,
    x2: 81.91,
    y2: 314.9,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 30.82,
    y1: 359.81,
    x2: 34.74,
    y2: 359.81,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 29.71,
    y1: 362.39,
    x2: 32.94,
    y2: 362.39,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 32.22,
    y1: 353.92,
    x2: 36.31,
    y2: 353.92,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 33.45,
    y1: 346.64,
    x2: 39.61,
    y2: 346.64,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 36.15,
    y1: 335.34,
    x2: 41.26,
    y2: 335.34,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 36.3,
    y1: 308.55,
    x2: 43.5,
    y2: 308.55,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 36.91,
    y1: 289.6,
    x2: 43.92,
    y2: 289.6,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 35.87,
    y1: 271.28,
    x2: 42.19,
    y2: 271.28,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 35.22,
    y1: 254.21,
    x2: 41.46,
    y2: 254.21,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 34.66,
    y1: 237.87,
    x2: 40.12,
    y2: 237.87,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 33.59,
    y1: 219.75,
    x2: 38.98,
    y2: 219.75,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 31.7,
    y1: 205.27,
    x2: 37.34,
    y2: 205.27,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 28.53,
    y1: 192.22,
    x2: 32.94,
    y2: 192.22,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 26.69,
    y1: 180.88,
    x2: 30.98,
    y2: 180.88,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 24.62,
    y1: 171.62,
    x2: 28.86,
    y2: 171.62,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 31.98,
    y1: 369.35,
    x2: 45.8,
    y2: 369.35,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 34.81,
    y1: 362.34,
    x2: 45.58,
    y2: 370.29,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 35.31,
    y1: 356.05,
    x2: 46.57,
    y2: 362.9,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 34.63,
    y1: 347.31,
    x2: 49.32,
    y2: 353.18,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1885.47,
    y1: 334.85,
    x2: 1895.54,
    y2: 338.59,
    gradientTransform: "translate(1249.77 1615.84) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#581818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9f3c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c06373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 40.52,
    y1: 321.68,
    x2: 54.09,
    y2: 323.48,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 41.34,
    y1: 308.61,
    x2: 56.51,
    y2: 305.18,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 41.34,
    y1: 290.34,
    x2: 58.93,
    y2: 284.48,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 38.71,
    y1: 272.15,
    x2: 56.6,
    y2: 263.95,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 38.28,
    y1: 252.84,
    x2: 52.96,
    y2: 241.91,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 39.04,
    y1: 233.13,
    x2: 51.7,
    y2: 222.61,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 36.69,
    y1: 215.61,
    x2: 51.75,
    y2: 202.33,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 34.79,
    y1: 202.29,
    x2: 49.8,
    y2: 186.46,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 32.59,
    y1: 185.2,
    x2: 46.64,
    y2: 174.58,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 28.97,
    y1: 176.14,
    x2: 42.02,
    y2: 163.57,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 26.62,
    y1: 161.75,
    x2: 37.71,
    y2: 150.65,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 26.23,
    y1: 156.39,
    x2: 36.84,
    y2: 147.09,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 56.43,
    y1: 145.14,
    x2: 63.12,
    y2: 145.14,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 57.27,
    y1: 387.26,
    x2: 61.67,
    y2: 385.6,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 50.06,
    y1: 190.71,
    x2: 64.63,
    y2: 184.85,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 42.87,
    y1: 165.87,
    x2: 58.22,
    y2: 157.21,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 41.07,
    y1: 155.48,
    x2: 57.38,
    y2: 145.37,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 46.9,
    y1: 175.39,
    x2: 62.27,
    y2: 168.13,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 52.98,
    y1: 205.01,
    x2: 71.42,
    y2: 206.32,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 54.84,
    y1: 224.62,
    x2: 73.44,
    y2: 226.09,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 57.03,
    y1: 245.3,
    x2: 74.43,
    y2: 249.32,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 58.12,
    y1: 269.31,
    x2: 78.19,
    y2: 274.37,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 58.7,
    y1: 290.64,
    x2: 76.81,
    y2: 295.67,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 57.94,
    y1: 310.18,
    x2: 75.91,
    y2: 317.7,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 58.05,
    y1: 329.19,
    x2: 73.61,
    y2: 336.56,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 55.91,
    y1: 343.18,
    x2: 70.43,
    y2: 353.13,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 53.59,
    y1: 357.07,
    x2: 65.66,
    y2: 366.16,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 50.8,
    y1: 367.44,
    x2: 61.08,
    y2: 374.78,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 47.26,
    y1: 373.78,
    x2: 58.72,
    y2: 382.49,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 45.4,
    y1: 376.75,
    x2: 54.45,
    y2: 383.88,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 39.41,
    y1: 148.53,
    x2: 54.58,
    y2: 139.06,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 39.09,
    y1: 143.51,
    x2: 50.72,
    y2: 135.97,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-56"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 27.38,
    y1: 167.66,
    x2: 38.64,
    y2: 156.08,
    gradientTransform: "translate(-122.27 243.8) rotate(45) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M156.16,319.01s-9.08-.15-18.46-3.38c-9.38-3.23-50.15-10.77-79.22-39.84-29.07-29.07-36.61-49.53-49.38-89.07,0,0-2.77-5.23-2.92-8.15-.15-2.92.31-8.92.31-8.92,0,0-2-8.46.15-15.84,2.15-7.38,6.31-24.77,7.69-29.23s10.46-41.23,50.46-79.38c0,0,42-37.07,89.22-36.61,0,0,2-2,7.38-2.77,5.38-.77,10.61-.15,11.38.92.77,1.08,15.07.31,18.77,2.15,3.69,1.85,16.46,6,21.07,7.85,4.61,1.85,35.38,14.15,62.61,41.38,27.23,27.23,37.69,66.61,37.69,66.61,0,0,3.84,8.46,5.69,13.38,1.85,4.92,1,12.23,1,12.23,0,0,3.77,10.08-2.23,21.62,0,0-1.07,4.46-2.61,11.84-1.54,7.38-9.08,52.46-45.69,89.07,0,0-26.3,24.46-55.07,34.15,0,0-31.69,8-36.77,10-5.08,2-11.84,5.69-21.07,2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M172.39,318.78s6.81-2.65,5.6-3.86-6.52,3.52-6.52,3.52l.92.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.16,314.28s4.15-1.62,3.87-2.36c-.29-.75-2.48-.87-3-.58-.52.29-.87,2.94-.87,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M310.22,151.34l-4.57,1.19-.69.16-1.54,1.15c-1.81,2.73-5.27,3.5-6.54,4.08-1.27.58-3.08.23-3.08.23l-.31,3c-2.19.5-8.03,2.34-8.03,2.34,0,0-3.09.71-3.2,2.39-.23,3.56-2.03,3.68-2.03,3.68l-6.19,2.58-3.81,2.19c.58,4.5-1.96,7.27-1.96,7.27-2.54,3-7.5,3.81-7.5,3.81l-4.73,3.35c-.23,6.23-9.69,8.77-9.69,8.77l-3.19,4.35c.73,2.04-3.04,6.04-3.04,6.04-3.23,2.77-11.54,8.31-11.54,8.31l-2.54,4.85c-2.88,4.5-10.38,8.08-10.38,8.08l-3.23,4.85s.69,2.31-2.31,5.54c-3,3.23-8.19,4.5-8.19,4.5l-2.77,5.77c.23,8.54-8.88,10.27-8.88,10.27l-.81,3.58-2.42.58s-.46,1.15-.69,4.38c-.23,3.23-4.96,5.65-4.96,5.65l-3.46,3.77c.11,8.04-5.77,9.15-5.77,9.15l-1.15,1.15-2.31,5.08c.35,2.65-4.69,9.77-4.69,9.77.5,2.27-3.9,7.02-3.9,7.02-1.23,5.95-6.68,8.23-7.6,8.58,2.26.22,3.66.25,3.66.25.35.14.69.25,1.03.37l.74-2.6,1.88-2.73,3.35-3.35c1.96-1.5,4.15-9.23,4.15-9.23,2.88-1.96,5.31-11.31,5.31-11.31,7.15-2.77,9.11-7.27,9.11-7.27l-1.62-5.31c7.38-1.85,12.92-11.08,12.92-11.08-.46-1.85,6.58-12.11,6.58-12.11,0,0,2.19-7.04,3.11-7.96s5.31-3.92,7.15-5.31c1.85-1.38,4.27-6.35,4.27-6.35,0,0,9.11-8.42,9.92-9.23s7.15-6.92,7.15-6.92c0,0,4.04-4.73,5.42-6.11s4.5-2.96,4.5-2.96l3.46-6.61c12.69-6,15-12.23,15-12.23,3.69-2.77,9.46-8.77,11.88-11.88,2.42-3.12,13.15-9.69,13.84-10.38s10.5-6.11,10.5-6.11l9-6.23,6.35-3.81,2.65-1.73,1.5-.35,4.6,1.24c-.19-.72-.34-1.12-.34-1.12l-6.11-1.04-3.27,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M275.5,190.53s4.42,4.58,6.15,5.15c1.73.58.61-8.92-.69-10.23l-5.46,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M142.09,315.24s-3.23-2.38-4.04-3.19,2.77,1.92,3.27,2.19c.5.27.77,1,.77,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M141.51,311.36s-3.58-2.58-3.31-2.92c.27-.35,2.92,1.85,2.92,1.85l.38,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M156.86,285.09s-5-3.31-4.69-4.23c.31-.92,4.69.23,6.85,2.39l-2.15,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M164.66,269.75s-4.38.46-5.88-1.5c-1.5-1.96.81-5.42,7.04-1.27l-1.15,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.97,295.67s-5.65-.81-6.46-1.38c-.81-.58-.81-4.73,5.54-.46l.92,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M290.99,142.26c-.11-.81-1.27-5.11-1.27-5.11,0,0,1.73-1.81,3.81,3.5l-2.54,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M301.15,137.19s-1.38-3.46-1.15-4.84c.23-1.38,1.62-3.46,1.73-1.96.11,1.5.12,2.88.58,3.81.46.92.58,3.35.58,3.35l-1.73-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M308.65,133.84s-1.85-2.08-1.85-3.69c0-1.62.23-3.23.81-1.5.58,1.73,1.04,4.04,1.5,4.5s-.46.69-.46.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M264.46,160.49s-2.88-5.5-1.73-7.12c1.15-1.62,3.92-1.54,5.31,3.08l-3.58,4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M277.96,147.45s-2.27-2.19-1.04-4.27c.67-1.12,3.81-.35,4.61,3.23l-3.58,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M175.65,254.78s-4.87-1.53-5.57-3.61c-.69-2.08,4.85-2.54,6.23-1.38,1.38,1.15,1.73,3.12,1.73,3.12l-2.39,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M187.97,237.44s-3.23.69-5.08-1.15.12-5.42,2.42-4.96c2.31.46,4.38,1.62,4.38,1.62l-1.73,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M203.04,220.68s-3.58-1.27-4.85-3.46c-1.27-2.19.69-7.15,7.85-.92l-3,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M218.73,201.53s-4.04-2.42-4.27-4.27c-.23-1.85,2.65-5.42,6.58-.11l-2.31,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M232.96,185.3s-4.04-4.27-2.77-5.77c1.27-1.5,4.38-1.85,6.92,1.62l-4.15,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.04,172.14s-3.35-2.65-3.23-4.62c.11-1.96,3.08-4.77,6.54,1l-3.31,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M311.76,172.95c.08.81,1.38-.23,1.5-2.19.11-1.96.23-4.15.23-4.15,0,0-2.31.46-1.73,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M315.95,166.45s-2.54,4.46-1.31,5.69c.59.59,1.96-5.88,1.96-5.88l-.66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M305.45,172.18s-1.85,3.62,1.69,3.77c1.15.05,2.08-3.23,2.08-5.54l-3.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M298.07,176.18s.42,4.5,1.58,5.42c1.15.92,2.54-6.46,2.42-9.34-.11-2.88-4,3.92-4,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M288.11,182.53s.08,6.08,2.88,4.27c1.38-.89,3.23-4.85,1.85-7.85l-4.73,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M267.11,201.68s4.38,3.46,6.12,2.65c1.73-.81,1.15-6.23-1.61-7.62-1.46-.73-4.5,4.96-4.5,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M251.88,215.45s2.39.92,2.73,1.73c.35.81,2.46,1.23,2.46,1.23,0,0,4.15-1.38,4.04-3.81-.12-2.42-.89-5.11-1.92-5.92-1.04-.81-7.31,6.77-7.31,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M241.39,228.79s6,1.85,7.5.58c1.5-1.27-.96-4.57-2.58-5.27-1.61-.69-4.92,4.69-4.92,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M230.66,242.29s3.35,2.65,6.11.12c2.77-2.54-.69-5.46-2.88-5.34-2.19.12-3.23,5.23-3.23,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M219.58,253.83s1.62,2.54,3.58,1.73c1.96-.81,4.46-2.35,3.69-3.69-1.04-1.81-6.23-.23-6.23-.23l-1.04,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M206.66,268.36s6,.46,7.15-.69,1.86-2.14,1.38-3.46c-.69-1.92-6.69,1.15-6.69,1.15l-1.85,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M197.89,279.44s3.12,1.27,5.65.35c2.54-.92,3.49-2.78,2.54-3.69-1.65-1.57-6.81.81-6.81.81l-1.38,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M192.01,292.02s4.38.23,6.11-1.5,1.5-2.34.81-3.11c-1.23-1.38-5.19,1.27-5.19,1.27l-1.73,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M185.78,301.25s5.65-.81,7.27-3.12c0,0-2.27-1.81-7.04,1.04l-.23,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M181.85,307.94s6.69-1.15,6.46-2.31c-.23-1.15-3.77-.84-9,3.23l2.54-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M202.97,217.6s-2.88-.81-3.69-1.85c-.81-1.04-.12-2.19.92-2.08,1.04.12,3.35,1.04,4.38,1.61,1.04.58-1.62,2.31-1.62,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M187.39,234.33s-1.62,0-2.54-.92.23-1.62,1.38-1.62c1.15,0,1.85.69,1.85.69l-.69,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M175.16,251.94l-2.35-2.65s2.92-.31,4.31.85l-1.96,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M218.73,198.6s-2.19.11-3.12-1.5c-.92-1.62.35-1.96,2.08-1.62,1.73.35,1.85-.23,3.35,1.73l-2.31,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M235.5,182.3s-2.77,1.15-3.81.11.46-3.69,1.73-3.11c1.27.58,2.31.69,2.08,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M249.92,171.1s-3.11-2.19-2.77-3.69c.35-1.5,3.35-1.5,4.96.12l-2.19,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M264.69,159.57s-2.31-4.15-1.73-4.73,3.58,2.19,3.58,2.19l-1.85,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M313.72,150.57c.06-.1.82-1.62,3.34.31,1.48,1.13.92,3.38,1.73,6.5.81,3.11.58,6.35-.58,7.96s-3.35,3.35-3.35,3.35c0,0,3.23-5.77,2.42-8.42-.81-2.65-2.54-8.42-3.58-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M319.26,167.76s3.81-7.27.58-13.27c0,0-.23,11.31-.58,13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M312.11,168.45s3.46-3,2.54-7.38c-.92-4.38-1.38-6.46-2.19-7.5s-1.23-2.84-1.23-2.84c0,0-1.36.78-2.86,1.05,0,0,2.37,3.29,3.06,5.13.69,1.85,1.73,6.81,1.73,6.81,0,0-1.15,3.69-1.04,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M303.45,157.88s-1.61-1.92-.54-2.54c1.08-.61,1.61-.84,3.15.69s3.85,5.69,4.23,8.54c.38,2.85-.23,5.77-2.62,7.69-2.39,1.92-2.92.92-2.23-.08.69-1,1.15-4.84.85-6.38-.31-1.54-.85-5.61-2.85-7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M293.65,158.99s2.35,1.58,4.04,3.12c1.69,1.54,4.85,4.38,4.84,6.54,0,2.15-.38,4.84-1.46,6.07s-2.77,2-3,1.62c-.23-.38.31-2.15.15-3.69-.15-1.54-1.46-3.92-2.54-5.77-1.08-1.85-3.82-5.35-3.82-5.35,0,0,1.67-.57,1.79-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M280.23,169.57s1.77,2.08,2.77,3.08,1.69,2.31,2.08,3.31c.38,1,1.54,2.62,2.31,4,.77,1.38.69,3.46.69,3.46,0,0,2.23-.08,3.69-1.54s1.85-5.85.69-7.61c-1.15-1.77-4.15-4.46-6-6.31s-4.46-1-4.46-1c.23,1.46-1.77,2.62-1.77,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M270.29,176.01s4.4,2.94,6.09,4.33c1.69,1.38,3.77,3.31,4.69,4.69.92,1.39,1.38,4.31.38,5-1,.69-2.31,2.31-3.08,2.31-.77,0-2.38-1-3.61-2.23s-4-4.31-4.38-4.85c-.38-.54-2.81-2.96-2.81-2.96,0,0,2.87-3.44,2.71-6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M256.04,188.76s2.35-.27,4.5.65c2.15.92,4.92,2.92,6.77,4,1.85,1.08,2.69,1.46,3.69,2.46l1.62,1.62s-4.15,4.77-4.92,4.62c-.77-.15-7.46-3.31-9.23-4.92-1.77-1.62-5-3.46-5-3.46,0,0,2.66-2.8,2.58-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M239.12,208.68s2.65-2.65,2.96-6.19l1.08-.61s10.08,3.77,10.54,3.92c.46.15,4.92,2.16,5.61,3,.69.85.39,2.23-1,3.31-1.38,1.08-2.92,1.69-3.84,2.31-.92.62-1.69,1.85-3.15.85-1.46-1-9.69-5.38-10.15-5.69-.46-.31-2.04-.89-2.04-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M224.46,223.1s2.92-2.54,2.5-6.19c0,0,2.15-.85,4.04-.12.74.29,2.77,2,4.38,2.23,1.61.23,7.38,2.15,8.46,2.77,1.08.62,4,3.69,3.31,4.69-.69,1-2.85,3.15-5.54,3.08-2.69-.08-9.38-1.54-10.92-2.77-1.54-1.23-6.23-3.69-6.23-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M211.85,234.79s1.54-.85,1.92-.77c.39.08,1.23,0,2.15.31.92.31,3.54.31,4.69.38,1.15.08,2.46.46,3.69,1.08,1.23.62,3.46,1,4.54,1.15,1.08.15,3.46.38,4.54.23,1.08-.15,2.08,1.62,1.08,2.62s-1.23,2-2.92,2.77c-1.69.77-5.46,2.54-8.23,2.54-2.77,0-5.69-.46-7.23-1.23-1.54-.77-4.92-2.31-5.46-2.54-.54-.23-1.77-.54-1.77-.54,0,0,3-4.54,3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M197.51,255.52s2.27-4.58,1.5-6.42c0,0,2.92.31,3.69.62.77.31,5.77,1.61,7.46,1.61,1.69,0,12.08-.08,12.08-.08,0,0-2.31,4.15-5.77,5.77-3.46,1.62-12.23,1.31-14.92.31-2.69-1-4.04-1.81-4.04-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M187.01,264.09s-.45,2.57-1.42,6.58c0,0,5.42,2.42,7.96,2.35,2.54-.08,8.77-.77,10.46-1.85,1.69-1.08,3.46-3,4.38-3.92s2.15-2.77,2.15-2.77c0,0-10,3.08-17.69,1.08l-3.62-1.31-2.23-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M177.93,278.02s2.08-.39,2.77-1.08c0,0,1.54,1.23,3.69,1.23,2.15,0,5.69.31,7.38,0,1.69-.31,6.85-1.31,8.15-1.69,1.31-.38,2.08-.54,2.08-.54,0,0-1.85,3.23-7.23,5.69-5.38,2.46-9.84,2.77-11.69,2.46-1.85-.31-5.61-2.08-5.61-2.08l.46-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M172.25,288.7s-2.74,2.74-3.59,2.97l-.27,3.42s4.38,2.39,6.31,2.77c1.92.38,5.61-.23,8.31-1.08,2.69-.85,3.15.54,5.31-1.15,2.15-1.69,4.54-4.39,5.54-5.54,1-1.15,1.23-2.15,1.23-2.15,0,0-9.08,3.84-14.61,3.54,0,0-3.92-.39-5.31-.69-1.38-.31-2.84-1.86-2.91-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M168.01,299.78s1.15,1.46,2.23,1.61c1.08.15,4.31,0,6-.31s3.46-.23,5.15-.69c1.69-.46,7.23-2.46,7.23-2.46,0,0-2.46,5.08-6.92,6.92-4.46,1.85-10.15,2.62-12.38,1.46-2.23-1.15-5.31-3.15-5.31-3.15l-.15-1.54s2.92-.46,4.15-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M159.55,312.09l-1.23,2.15s2.92,2.15,4.46,2.31,3.62.54,5.61-.08c2-.61,5.38-1.08,6.77-1.69,1.38-.62,2.85-1.77,2.85-2.38,0-.62-.85-.54-.85-.54,0,0-5.31,1-7.31,1.77-2,.77-4.85,1.31-6.46,1.23-1.62-.08-3.08-.46-3.85-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M157.93,316.78s5.92,1.92,7.92,1.62c2-.31,4-.92,5.15-1.15,1.15-.23,5.85-2.46,5.85-2.46,0,0-2.69,4.38-6,5.38-3.31,1-8.08,1.77-10,1.08-1.92-.69-3.69-3.23-2.92-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M144.7,304.24s-7.15-2.08-6.46-2.77,5.54.54,7.27,2.19l-.81.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M312.69,133.49s-1.62-3-1.15-3.46,2.54,4.61,2.54,4.61l-1.38-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M164.55,266.4s-2.19.58-.58,3.58c1.61,3,2.77,5.08,5.31,6.23,2.54,1.15,5.19,2.19,7.27,1.96,2.08-.23,3.58-.58,3.58-.58,0,0,2-1.54,1.27-3.35,0,0-4.04-.58-6-1.85-1.96-1.27-5.77-3.23-7.15-4.15-1.38-.92-3.69-1.85-3.69-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M147.47,292.94s3.69,1.15,7.04,2.65c3.35,1.5,8.42,1.96,10.61,1.62,2.19-.35,3.12-1.42,3.12-1.42,0,0,.46,3.85-.35,4.65s-3.69,1.85-7.38,1.15c-3.69-.69-7.04-1.5-9.35-3.35-2.31-1.85-3.46-3.46-3.69-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M143.32,302.4s3.11.81,4.61,1.61c1.5.81,3,.92,5.31,1.38,2.31.46,4.96,1.96,6.23,1.61,1.27-.35,3.46-.69,3.46-.69,0,0-.69,2.31-3,2.77-2.31.46-5.08.23-7.5-.58-2.42-.81-4.61-1.38-6.35-2.42-1.73-1.04-2.31-1.38-2.77-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M156.59,281.75s1.38.46,3.58,1.5c2.19,1.04,2.19,1.5,4.38,2.31,2.19.81,8.38,1.31,8.38,1.31,0,0-.19,2.5-2.38,4.23s-4.5,1.04-6.92-.46c-2.42-1.5-5.54-3.69-6.92-5.08s-2.31-2.54-2.31-2.54c0,0-.77-3.38,2.19-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M175.05,249.44s1.96.12,3.11,1.27,2.54,2.77,4.04,3.81c1.5,1.04,3.58,4.04,5.19,4.5,1.62.46,2.88,1.04,2.88,1.04,0,0,1.15,2.54-.81,3.58-1.96,1.04-5.54,1.15-8.42-1.5-2.88-2.65-7.61-7.38-6-12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M187.62,232.02s1.38.23,2.08.92,1.38,2.08,2.65,2.65c1.27.58,1.96.12,3.92,2.08s7.01,8.04,7.15,8.54c.55,1.93-.58,3.12-.58,3.12,0,0-2.69.84-3.96.27-1.27-.58-1.81-.04-4.35-2.57s-4.85-4.15-6-6.23c-1.15-2.08-1.85-6.69-.92-8.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M204.58,215.29s-2.88-.12-2.54,1.85c.35,1.96,1.15,6.69,2.54,8.54,1.38,1.85,2.31,2.77,4.15,4.61s3.11,4.5,3.11,4.5c0,0,1.18-.26,2.57-.49,1.38-.23,2.39-1.47,1.93-3.78-.46-2.31-.92-3.69-3.58-7.5-2.65-3.81-3.46-5.77-8.19-7.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M219.12,203.76s-1.5-3.58-.92-4.85c.58-1.27,1.96-2.65,1.96-2.65l4.27,4.27c1.5,1.5,1.73,1.5,3.23,3.92,1.5,2.42,2.19,3.35,3.12,5.65l.92,2.31,2.12.19s-1.19,2.12-2.46,2.92c-1.27.81-4.39,1.39-4.39,1.39,0,0-7.27-9.58-7.84-13.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M242.08,202.49s-3.11-6.81-3.58-7.96c-.46-1.15-2.77-3.69-3.58-4.73-.81-1.04-3.46-6.23-3.46-6.23,0,0,.38-1.54,1.08-2.69.69-1.15,2.96-1.42,2.96-1.42,0,0,3.58,3.42,4.96,4.58,1.38,1.15,2.42,4.96,3.69,6.69,1.27,1.73,2.54,5.77,2.19,6.81-.35,1.04-1.27,3.5-4.27,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M256.04,188.76s-2.42-7.5-2.88-9.35c-.46-1.85-1.5-2.65-2.19-4.27-.69-1.62-1.96-4.96-1.96-4.96,0,0,1.04-3.57,3.11-2.65,2.08.92,3.35,1.5,4.73,3.81,1.38,2.31,1.96,2.19,2.65,4.5.69,2.31,1.04,8.88,1.04,8.88,0,0,.11,2.19-1.85,3.46l-2.65.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M270.29,176.01s-1.1-7.79-2.83-10.44c-1.73-2.65-3-4.15-3-5.08,0-.92-.69-3.69,1.38-3.92,2.08-.23,2.42-1.04,4.27,1.5,1.85,2.54,3.69,4.61,4.04,7.5.35,2.88-.11,6.58-.11,6.58,0,0,.17,2.94-3.75,3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M282,166.95s-.12-6.11-.46-8.77c-.35-2.65-1.85-5.08-2.65-6.81-.81-1.73-1.61-4.85-1.61-4.85,0,0,2.65-1.73,4.27-.12s4.27,3.58,4.5,6.35c.23,2.77.35,7.5,0,8.54-.35,1.04-.46,4.85-4.04,5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M296.11,158.3s1.58-3.35,1.93-5.31c.35-1.96.58-6.11-2.65-10.73-3.23-4.61-5.08-3.23-5.08-3.23,0,0,.58,3.34.92,4.61.35,1.27,2.08,4.38,2.54,6.23.46,1.85-.12,9.11-.12,9.11,0,0,1.5.58,2.46-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M303.22,154.26s.92-6.46.23-8.77c-.69-2.31-2.08-6.23-2.31-6.69-.23-.46-1.27-4.5.69-3,1.96,1.5,4.5,4.5,4.5,7.04,0,2.54.12,5.65-.35,7.5-.46,1.85-.23,3-2.77,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M311.07,150.8s.69-7.15.12-9.81c-.58-2.65-2.54-5.54-2.88-6.35-.35-.81-1.27-4.04.46-2.54,1.73,1.5,3.81,3.11,4.38,7.15.58,4.04.81,9.34.35,10.04-.46.69-.58,1.5-2.42,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M315.57,147.92s-.23-8.77-1.27-11.42c-1.04-2.65-2.15-4.15-2.15-4.15,0,0,4.23,3.92,4,6.69-.23,2.77,1.38,6.69-.58,8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M158.32,314.24s-8.84,1.31-10.61.62c-1.77-.69-3.85-1.08-5.46-2.54-1.61-1.46-2.38-2.77-2.38-2.77,0,0,3.92,1.38,7.08,2.38,3.15,1,7.77,1.15,9.77.85,2-.31,2.85-.69,2.85-.69l-1.23,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M140.17,313.63s2.31.62,4.15,1.54c1.85.92,3.38,1.54,5.08,1.54,1.69,0,6.56-.92,6.56,0,0,0-3.56,3-6.25,2.62,0,0-4.58-1.5-6.92-3.31-2.35-1.81-2.61-2.39-2.61-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M163.7,309.78s6.08,1.46,9.38.46c3.31-1,5.85-1.54,7.38-2.46,1.54-.92,3.92-2.08,3.92-2.08,0,0-1.77,3.62-5.38,5.23-3.61,1.62-8.92,3.23-12.08,2.54-3.15-.69-4.85-1.15-5.62-1.77-.77-.62-1.42-1.27-.81-1.88s3.19-.04,3.19-.04Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M155.86,7.66s9.31-6.23,15.92-1.46c0,0-13.96,1.12-15.92,1.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M6.48,152.87s2.65-6.81,3.86-5.6-3.52,6.52-3.52,6.52l-.35-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M10.98,150.1s1.62-4.15,2.36-3.87c.75.29.87,2.48.58,3-.29.52-2.94.87-2.94.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8.48,167.33l-2.36.3c.19,1.25.37,2.02.37,2.02,0,0-.08.99-.16,2.36.08.23.14.48.17.76.35-.92,2.63-6.37,8.58-7.6,0,0,4.75-4.4,7.02-3.9,0,0,7.11-5.04,9.77-4.69l5.08-2.31,1.15-1.15s1.12-5.88,9.15-5.77l3.77-3.46s2.42-4.73,5.65-4.96c3.23-.23,4.38-.69,4.38-.69l.58-2.42,3.58-.81s1.73-9.11,10.27-8.88l5.77-2.77s1.27-5.19,4.5-8.19c3.23-3,5.54-2.31,5.54-2.31l4.85-3.23s3.58-7.5,8.08-10.38l4.85-2.54s5.54-8.31,8.31-11.54c0,0,4-3.77,6.04-3.04l4.35-3.19s2.54-9.46,8.77-9.69l3.35-4.73s.81-4.96,3.81-7.5c0,0,2.77-2.54,7.27-1.96l2.19-3.81,2.58-6.19s.12-1.8,3.68-2.03c1.68-.11,2.39-3.2,2.39-3.2,0,0,1.84-5.84,2.34-8.04l3-.31s-.35-1.81.23-3.07c.58-1.27,1.35-4.73,4.08-6.54l1.15-1.54.16-.69,1.19-4.57,2.04-3.27-.77-4.52c-.33-.03-.63-.06-.9-.09l.74,2.77-.35,1.5-1.73,2.65-3.81,6.35-6.23,9s-5.42,9.81-6.11,10.5-7.27,11.42-10.38,13.84c-3.11,2.42-9.11,8.19-11.88,11.88,0,0-6.23,2.31-12.23,15l-6.61,3.46s-1.58,3.11-2.96,4.5-6.11,5.42-6.11,5.42c0,0-6.12,6.35-6.92,7.15s-9.23,9.92-9.23,9.92c0,0-4.96,2.42-6.35,4.27-1.38,1.85-4.38,6.23-5.31,7.15s-7.96,3.12-7.96,3.12c0,0-10.27,7.04-12.11,6.58,0,0-9.23,5.54-11.08,12.92l-5.31-1.62s-4.5,1.96-7.27,9.12c0,0-9.35,2.42-11.31,5.31,0,0-7.73,2.19-9.23,4.15l-3.35,3.35-2.73,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M134.73,49.76s-4.58-4.42-5.15-6.15c-.58-1.73,8.92-.61,10.23.69l-5.08,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M10.02,183.17s2.38,3.23,3.19,4.04-1.92-2.77-2.19-3.27c-.27-.5-1-.77-1-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M13.9,183.75s2.58,3.58,2.92,3.31c.35-.27-1.85-2.92-1.85-2.92l-1.08-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.17,168.4s3.31,5,4.23,4.69c.92-.31-.23-4.69-2.38-6.84l-1.85,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M55.51,160.6s-.46,4.38,1.5,5.88c1.96,1.5,5.42-.81,1.27-7.04l-2.77,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M29.59,175.29s.81,5.65,1.38,6.46c.58.81,4.73.81.46-5.54l-1.85-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M183,34.27c.81.11,5.11,1.27,5.11,1.27,0,0,1.81-1.73-3.5-3.81l-1.62,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M188.08,24.11s3.46,1.39,4.84,1.15c1.39-.23,3.46-1.62,1.96-1.73-1.5-.12-2.88-.12-3.81-.58-.92-.46-3.35-.58-3.35-.58l.35,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M191.42,16.61s2.08,1.84,3.69,1.85c1.62,0,3.23-.23,1.5-.81-1.73-.58-4.04-1.04-4.5-1.5s-.69.46-.69.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M164.77,60.8s5.5,2.88,7.12,1.73c1.62-1.15,1.54-3.92-3.08-5.31l-4.04,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M177.81,47.3s2.19,2.27,4.27,1.04c1.12-.67.35-3.81-3.23-4.61l-1.04,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M70.48,149.61s1.53,4.87,3.61,5.57c2.08.69,2.54-4.85,1.38-6.23-1.15-1.38-3.12-1.73-3.12-1.73l-1.88,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M87.82,137.29s-.69,3.23,1.15,5.08,5.42-.11,4.96-2.42c-.46-2.31-1.62-4.38-1.62-4.38l-4.5,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M104.58,122.22s1.27,3.58,3.46,4.85c2.19,1.27,7.15-.69.92-7.84l-4.38,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M123.74,106.53s2.42,4.04,4.27,4.27c1.85.23,5.42-2.65.12-6.58l-4.38,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.96,92.3s4.27,4.04,5.77,2.77c1.5-1.27,1.85-4.38-1.62-6.92l-4.15,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M153.12,75.22s2.65,3.34,4.61,3.23c1.96-.12,4.77-3.08-1-6.54l-3.62,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M152.31,13.5c-.81-.08.23-1.39,2.19-1.5,1.96-.12,4.15-.23,4.15-.23,0,0-.46,2.31-6.35,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M158.81,9.31s-4.46,2.54-5.69,1.31c-.59-.59,5.88-1.96,5.88-1.96l-.2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.08,19.81s-3.62,1.85-3.77-1.69c-.05-1.15,3.23-2.08,5.54-2.08l-1.77,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M149.08,27.19s-4.5-.42-5.42-1.58c-.92-1.15,6.46-2.54,9.34-2.42,2.88.11-3.92,4-3.92,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M142.73,37.15s-6.08-.08-4.27-2.88c.89-1.38,4.84-3.23,7.85-1.85l-3.58,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.58,58.15s-3.46-4.38-2.65-6.11c.81-1.73,6.23-1.15,7.62,1.61.73,1.46-4.96,4.5-4.96,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M109.81,73.38s-.92-2.39-1.73-2.73c-.81-.35-1.23-2.46-1.23-2.46,0,0,1.39-4.15,3.81-4.04,2.42.11,5.11.89,5.92,1.92.81,1.04-6.77,7.31-6.77,7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M96.47,83.88s-1.85-6-.58-7.5c1.27-1.5,4.57.96,5.27,2.58.69,1.61-4.69,4.92-4.69,4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M82.97,94.61s-2.65-3.35-.11-6.11c2.54-2.77,5.46.69,5.34,2.88-.12,2.19-5.23,3.23-5.23,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M71.43,105.68s-2.54-1.62-1.73-3.58c.81-1.96,2.35-4.46,3.69-3.69,1.81,1.04.23,6.23.23,6.23l-2.19,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.9,118.6s-.46-6,.69-7.15,2.14-1.86,3.46-1.38c1.92.69-1.15,6.69-1.15,6.69l-3,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M45.82,127.37s-1.27-3.11-.35-5.65c.92-2.54,2.78-3.49,3.69-2.54,1.57,1.66-.81,6.81-.81,6.81l-2.54,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M33.25,133.26s-.23-4.38,1.5-6.12,2.34-1.5,3.12-.81c1.38,1.23-1.27,5.19-1.27,5.19l-3.35,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M24.02,139.49s.81-5.65,3.12-7.27c0,0,1.81,2.27-1.04,7.04l-2.08.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M17.32,143.41s1.15-6.69,2.31-6.46c1.15.23.84,3.77-3.23,9l.92-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M107.66,122.29s.81,2.88,1.85,3.69c1.04.81,2.19.12,2.08-.92-.12-1.04-1.04-3.35-1.61-4.38-.58-1.04-2.31,1.62-2.31,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M90.93,137.87s0,1.62.92,2.54,1.62-.23,1.62-1.38c0-1.15-.69-1.85-.69-1.85l-1.85.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M73.32,150.1l2.65,2.35s.31-2.92-.85-4.31l-1.81,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M126.66,106.53s-.11,2.19,1.5,3.12c1.62.92,1.96-.35,1.62-2.08-.35-1.73.23-1.85-1.73-3.35l-1.38,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M142.97,89.76s-1.15,2.77-.11,3.81,3.69-.46,3.11-1.73c-.58-1.27-.69-2.31-3-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M154.16,75.34s2.19,3.12,3.69,2.77c1.5-.35,1.5-3.35-.12-4.96l-3.58,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M165.69,60.57s4.15,2.31,4.73,1.73-2.19-3.58-2.19-3.58l-2.54,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M174.69,11.54c.1-.06,1.62-.82-.31-3.34-1.13-1.48-1.79-2.04-4.9-2.85-3.11-.81-7.94.54-9.55,1.69-1.62,1.15-3.35,3.35-3.35,3.35,0,0,5.77-3.23,8.42-2.42,2.65.81,8.42,2.54,9.69,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M156.81,13.15s3-3.46,7.38-2.54c4.38.92,6.46,1.38,7.5,2.19,1.04.81,2.84,1.23,2.84,1.23,0,0-.78,1.36-1.05,2.86,0,0-3.29-2.37-5.13-3.06-1.85-.69-6.81-1.73-6.81-1.73,0,0-3.69,1.15-4.73,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M167.39,21.81s1.92,1.61,2.54.54c.61-1.08.85-1.61-.69-3.15s-5.69-3.85-8.54-4.23c-2.85-.38-5.77.23-7.69,2.62-1.92,2.39-.92,2.92.08,2.23,1-.69,4.84-1.15,6.38-.85,1.54.31,5.61.85,7.92,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M166.27,31.61s-1.58-2.34-3.12-4.04c-1.54-1.69-4.38-4.84-6.54-4.84-2.15,0-4.84.38-6.07,1.46-1.23,1.08-2,2.77-1.62,3,.38.23,2.15-.31,3.69-.15,1.54.15,3.92,1.46,5.77,2.54,1.85,1.08,5.35,3.82,5.35,3.82,0,0,.57-1.67,2.54-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M141.85,37.19s2.08-.08,3.46.69c1.38.77,3,1.92,4,2.31,1,.39,2.31,1.08,3.31,2.08s3.08,2.77,3.08,2.77c0,0,1.15-2,2.62-1.77,0,0,.85-2.62-1-4.46s-4.54-4.85-6.31-6c-1.77-1.15-6.15-.77-7.62.69s-1.54,3.69-1.54,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M149.25,54.98s-2.94-4.4-4.33-6.09c-1.38-1.69-3.31-3.77-4.69-4.69-1.39-.92-4.31-1.38-5-.38-.69,1-2.31,2.31-2.31,3.08,0,.77,1,2.38,2.23,3.61s4.31,4,4.85,4.38c.54.38,2.96,2.81,2.96,2.81,0,0,3.44-2.87,6.29-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M136.5,69.22s.27-2.35-.66-4.5c-.92-2.15-2.92-4.92-4-6.77-1.08-1.85-1.46-2.69-2.46-3.69l-1.62-1.62s-4.77,4.15-4.62,4.92c.15.77,3.31,7.46,4.92,9.23,1.61,1.77,3.46,5,3.46,5,0,0,2.8-2.66,4.96-2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M116.58,86.14s2.65-2.65,6.19-2.96l.61-1.08s-3.77-10.08-3.92-10.54c-.15-.46-2.16-4.92-3-5.61-.85-.69-2.23-.38-3.31,1-1.08,1.38-1.69,2.92-2.31,3.84-.62.92-1.85,1.69-.85,3.16,1,1.46,5.38,9.69,5.69,10.15.31.46.89,2.04.89,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M102.16,100.8s2.54-2.92,6.19-2.5c0,0,.85-2.15.12-4.04-.29-.74-2-2.77-2.23-4.38-.23-1.61-2.15-7.38-2.77-8.46-.61-1.08-3.69-4-4.69-3.31-1,.69-3.15,2.85-3.08,5.54.08,2.69,1.54,9.38,2.77,10.92,1.23,1.54,3.69,6.23,3.69,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M90.47,113.41s.84-1.54.77-1.92c-.08-.39,0-1.23-.31-2.15-.31-.92-.31-3.54-.39-4.69-.08-1.15-.46-2.46-1.08-3.69-.62-1.23-1-3.46-1.15-4.54-.15-1.08-.38-3.46-.23-4.54.15-1.08-1.62-2.08-2.62-1.08s-2,1.23-2.77,2.92c-.77,1.69-2.54,5.46-2.54,8.23,0,2.77.46,5.69,1.23,7.23.77,1.54,2.31,4.92,2.54,5.46.23.54.54,1.77.54,1.77,0,0,4.54-3,6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M69.74,127.75s4.58-2.27,6.42-1.5c0,0-.31-2.92-.62-3.69-.31-.77-1.62-5.77-1.62-7.46,0-1.69.08-12.08.08-12.08,0,0-4.15,2.31-5.77,5.77-1.62,3.46-1.31,12.23-.31,14.92,1,2.69,1.81,4.04,1.81,4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M61.17,138.25s-2.57.45-6.58,1.42c0,0-2.42-5.42-2.35-7.96.08-2.54.77-8.77,1.85-10.46,1.08-1.69,3-3.46,3.92-4.38s2.77-2.15,2.77-2.15c0,0-3.08,10-1.08,17.69l1.31,3.62.16,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M47.24,147.33s.39-2.08,1.08-2.77c0,0-1.23-1.54-1.23-3.69,0-2.15-.31-5.69,0-7.38.31-1.69,1.31-6.85,1.69-8.15.38-1.31.54-2.08.54-2.08,0,0-3.23,1.85-5.69,7.23-2.46,5.38-2.77,9.84-2.46,11.69.31,1.85,2.08,5.62,2.08,5.62l4-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M36.56,153.01s-2.74,2.74-2.97,3.58l-3.42.27s-2.39-4.38-2.77-6.31c-.38-1.92.23-5.61,1.08-8.31.85-2.69-.54-3.15,1.15-5.31,1.69-2.15,4.38-4.54,5.54-5.54,1.15-1,2.15-1.23,2.15-1.23,0,0-3.84,9.08-3.54,14.61,0,0,.39,3.92.69,5.31.31,1.38,1.85,2.84,2.09,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M25.48,157.25s-1.46-1.15-1.62-2.23c-.15-1.08,0-4.31.31-6s.23-3.46.69-5.15c.46-1.69,2.46-7.23,2.46-7.23,0,0-5.08,2.46-6.92,6.92-1.85,4.46-2.62,10.15-1.46,12.38,1.15,2.23,3.15,5.31,3.15,5.31l1.54.15s.46-2.92,1.85-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M13.17,165.71l-2.15,1.23s-2.15-2.92-2.31-4.46c-.15-1.54-.54-3.62.08-5.62.61-2,1.08-5.38,1.69-6.77.61-1.39,1.77-2.85,2.38-2.85.62,0,.54.85.54.85,0,0-1,5.31-1.77,7.31-.77,2-1.31,4.84-1.23,6.46.08,1.62.46,3.08,2.77,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M8.48,167.33s-1.92-5.92-1.62-7.92c.31-2,.92-4,1.15-5.15.23-1.15,2.46-5.85,2.46-5.85,0,0-4.38,2.69-5.38,6-1,3.31-1.77,8.08-1.08,10,.69,1.92,3.23,3.69,4.46,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M21.02,180.56s2.08,7.15,2.77,6.46-.54-5.54-2.19-7.27l-.58.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M191.77,12.57s3,1.62,3.46,1.15-4.61-2.54-4.61-2.54l1.15,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M58.86,160.71s-.58,2.19-3.58.58c-3-1.62-5.08-2.77-6.23-5.31-1.15-2.54-2.19-5.19-1.96-7.27.23-2.08.58-3.58.58-3.58,0,0,1.54-2,3.35-1.27,0,0,.58,4.04,1.85,6,1.27,1.96,3.23,5.77,4.15,7.15.92,1.38,1.85,3.69,1.85,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M32.32,177.79s-1.15-3.69-2.65-7.04c-1.5-3.35-1.96-8.42-1.62-10.61.35-2.19,1.42-3.12,1.42-3.12,0,0-3.85-.46-4.65.35s-1.85,3.69-1.15,7.38c.69,3.69,1.5,7.04,3.34,9.34,1.85,2.31,3.46,3.46,5.31,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M22.86,181.94s-.81-3.12-1.62-4.62c-.81-1.5-.92-3-1.38-5.31-.46-2.31-1.96-4.96-1.62-6.23.35-1.27.69-3.46.69-3.46,0,0-2.31.69-2.77,3-.46,2.31-.23,5.08.58,7.5.81,2.42,1.38,4.61,2.42,6.35,1.04,1.73,1.38,2.31,3.69,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M43.51,168.67s-.46-1.38-1.5-3.58c-1.04-2.19-1.5-2.19-2.31-4.38-.81-2.19-1.31-8.38-1.31-8.38,0,0-2.5.19-4.23,2.38-1.73,2.19-1.04,4.5.46,6.92,1.5,2.42,3.69,5.54,5.08,6.92s2.54,2.31,2.54,2.31c0,0,3.38.77,1.27-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M75.82,150.21s-.12-1.96-1.27-3.12-2.77-2.54-3.81-4.04c-1.04-1.5-4.04-3.58-4.5-5.19-.46-1.62-1.04-2.88-1.04-2.88,0,0-2.54-1.15-3.58.81-1.04,1.96-1.15,5.54,1.5,8.42,2.65,2.88,7.38,7.61,12.69,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M93.24,137.64s-.23-1.38-.92-2.08-2.08-1.38-2.65-2.65c-.58-1.27-.12-1.96-2.08-3.92s-8.04-7.01-8.54-7.15c-1.93-.55-3.11.58-3.11.58,0,0-.84,2.69-.27,3.96.58,1.27.04,1.81,2.57,4.35s4.15,4.85,6.23,6c2.08,1.15,6.69,1.85,8.77.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M109.97,120.68s.11,2.88-1.85,2.54-6.69-1.15-8.54-2.54c-1.85-1.38-2.77-2.31-4.61-4.15s-4.5-3.11-4.5-3.11c0,0,.26-1.18.49-2.57.23-1.38,1.47-2.39,3.78-1.93s3.69.92,7.5,3.58c3.81,2.65,5.77,3.46,7.73,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M121.51,106.14s3.58,1.5,4.85.92c1.27-.58,2.65-1.96,2.65-1.96l-4.27-4.27c-1.5-1.5-1.5-1.73-3.92-3.23-2.42-1.5-3.34-2.19-5.65-3.12l-2.31-.92-.19-2.12s-2.12,1.19-2.92,2.46c-.81,1.27-1.39,4.39-1.39,4.39,0,0,9.58,7.27,13.15,7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M122.77,83.18s6.81,3.11,7.96,3.58c1.15.46,3.69,2.77,4.73,3.58,1.04.81,6.23,3.46,6.23,3.46,0,0,1.54-.38,2.69-1.08s1.42-2.96,1.42-2.96c0,0-3.42-3.58-4.58-4.96-1.15-1.38-4.96-2.42-6.69-3.69-1.73-1.27-5.77-2.54-6.81-2.19-1.04.35-3.5,1.27-4.96,4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M136.5,69.22s7.5,2.42,9.35,2.88c1.85.46,2.65,1.5,4.27,2.19,1.62.69,4.96,1.96,4.96,1.96,0,0,3.57-1.04,2.65-3.11-.92-2.08-1.5-3.35-3.81-4.73-2.31-1.38-2.19-1.96-4.5-2.65-2.31-.69-8.88-1.04-8.88-1.04,0,0-2.19-.12-3.46,1.85l-.58,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M149.25,54.98s7.79,1.1,10.44,2.83c2.66,1.73,4.15,3,5.08,3,.92,0,3.69.69,3.92-1.38.23-2.08,1.04-2.42-1.5-4.27-2.54-1.85-4.61-3.69-7.5-4.04-2.88-.35-6.58.12-6.58.12,0,0-2.94-.17-3.86,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M158.31,43.26s6.11.12,8.77.46c2.65.35,5.08,1.85,6.81,2.65,1.73.81,4.85,1.61,4.85,1.61,0,0,1.73-2.65.12-4.27s-3.58-4.27-6.35-4.5c-2.77-.23-7.5-.35-8.54,0-1.04.35-4.85.46-5.65,4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M166.96,29.15s3.35-1.58,5.31-1.93c1.96-.35,6.11-.58,10.73,2.65,4.61,3.23,3.23,5.08,3.23,5.08,0,0-3.34-.58-4.61-.92-1.27-.35-4.38-2.08-6.23-2.54-1.85-.46-9.11.12-9.11.12,0,0-.58-1.5.69-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M171,22.04s6.46-.92,8.77-.23c2.31.69,6.23,2.08,6.69,2.31.46.23,4.5,1.27,3-.69-1.5-1.96-4.5-4.5-7.04-4.5-2.54,0-5.65-.12-7.5.35-1.85.46-3,.23-3.92,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M174.46,14.19s7.15-.69,9.81-.12c2.65.58,5.54,2.54,6.34,2.88.81.35,4.04,1.27,2.54-.46-1.5-1.73-3.12-3.81-7.15-4.38-4.04-.58-9.35-.81-10.04-.35-.69.46-1.5.58-1.5,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M175.68,10.04s10.43-.12,13.09.92c2.65,1.04,4.15,2.15,4.15,2.15,0,0-3.92-4.23-6.69-4-2.77.23-8.36-1.03-10.55.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M11.02,166.94s-1.31,8.85-.61,10.61c.69,1.77,1.08,3.85,2.54,5.46,1.46,1.62,2.77,2.38,2.77,2.38,0,0-1.38-3.92-2.38-7.08-1-3.16-1.15-7.77-.85-9.77.31-2,.69-2.85.69-2.85l-2.15,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M11.63,185.1s-.62-2.31-1.54-4.15c-.92-1.85-1.54-3.38-1.54-5.08,0-1.69.92-6.56,0-6.56,0,0-3,3.56-2.62,6.25,0,0,1.5,4.58,3.31,6.92,1.81,2.35,2.39,2.61,2.39,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M15.48,161.56s-1.46-6.08-.46-9.38c1-3.31,1.54-5.85,2.46-7.39.92-1.54,2.08-3.92,2.08-3.92,0,0-3.61,1.77-5.23,5.38-1.62,3.61-3.23,8.92-2.54,12.07.69,3.15,1.15,4.85,1.77,5.62.61.77,1.27,1.42,1.89.81s.04-3.19.04-3.19Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M111.25,215.52c-1.29-.53-2.74-.76-4.37-.69-1.63.07-3.25.39-4.87.97-1.62.58-3.2,1.31-4.74,2.22-4.51,2.74-9.37,4.52-14.57,5.35-.43.08-1.04,0-1.83-.25-.78-.25-1.38-.62-1.8-1.12-1.52-1.81-2.74-3.86-3.68-6.17-.94-2.31-1.39-4.35-1.34-6.14.03-2.93,1.42-6.63,4.16-11.1,2.74-4.47,6.49-8.7,11.26-12.7,2.85-2.39,5.24-4.01,7.17-4.86,1.93-.85,3.29-.8,4.08.14,1.29,1.54,2.09,2.9,2.39,4.08.3,1.18.33,2.11.1,2.77-.23.67-.73,1.73-1.5,3.18-.87,1.5-1.55,2.88-2.06,4.14s-.9,2.4-1.17,3.39c-.27,1-.49,1.57-.65,1.7-.2.17-.37.17-.5,0-.29-.35-.39-1.17-.28-2.47.11-1.3.45-2.64,1.03-4.04.59-1.51.81-2.34.68-2.51-.22-.27-.94.11-2.15,1.12-3.66,3.07-6.76,6.25-9.29,9.53-2.54,3.28-4.23,6.23-5.09,8.84-.86,2.61-.81,4.49.16,5.64.6.72,1.4.92,2.39.59.99-.32,3.05-1.2,6.16-2.63,3.12-1.43,6.05-2.52,8.81-3.3,3.93-1.13,7.17-1.59,9.71-1.38,2.54.21,4.52,1.17,5.95,2.88.98,1.17,1.7,2.57,2.14,4.21.45,1.64.56,3.39.34,5.25-.22,1.86-.75,3.69-1.58,5.47-.74,1.49-1.8,3.21-3.19,5.14-1.39,1.94-3.01,3.9-4.86,5.89-1.85,1.99-3.72,3.77-5.59,5.35-3.46,2.9-6.53,4.9-9.2,5.99-2.67,1.09-4.59.95-5.74-.43-.52-.62-.97-1.87-1.35-3.77-.38-1.9-.28-3.48.31-4.75.56-1.06,1.21-1.95,1.96-2.67.75-.71,1.23-.95,1.43-.7.05.06.07.15.07.26s-.03.22-.08.33c-.04.11-.09.22-.13.32-.26.5-.47.89-.64,1.19-.17.3-.29.56-.36.77s-.04.41.1.57c.36.43,2.59-1.07,6.68-4.51,3.56-2.99,6.36-5.57,8.41-7.74,2.05-2.17,3.65-4.34,4.81-6.5,1.15-2.16,1.93-4.45,2.32-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.14,191.49l1.73,2.06c-.27,2.33-.63,4.03-1.08,5.1-.45,1.07-1.45,2.19-3,3.35.08,5.32-.86,8.8-2.81,10.44-1.11.93-2.43,1.4-3.98,1.4-1.55,0-3.14-.42-4.79-1.28-1.65-.86-3.15-2.1-4.51-3.72-1.1-1.31-1.9-3.12-2.41-5.43-.5-2.31-.67-4.71-.5-7.22s.66-4.82,1.47-6.95c.81-2.13,1.86-3.74,3.17-4.84.93-.78,1.79-1.24,2.57-1.4.78-.15,1.4.04,1.85.57.34.41.51,1.07.51,1.99.89-.47,1.63-.63,2.23-.48.6.15,1.32.72,2.16,1.73s1.65,2.41,2.46,4.28c.81,1.87,1.38,3.79,1.71,5.75l1,.11.44-.37c.34-.28.59-.65.77-1.1.18-.45.32-.88.41-1.29.09-.41.29-1.32.59-2.73ZM125.24,188.52c-.78,2.4-1.41,4.51-1.87,6.32-.47,1.81-.75,3.48-.85,5.01-.1,1.53.08,2.85.53,3.94,1.43,2.71,2.23,4.16,2.38,4.35,1.14,1.35,2.61,1.27,4.43-.26.85-.71,1.64-2.67,2.36-5.86-1.15-.68-2.09-1.46-2.83-2.35-1.08-1.29-1.93-2.83-2.55-4.6-.61-1.78-1.15-3.96-1.6-6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.66,177.74l1.78,2.12c-.15,2.23-.3,3.87-.45,4.94-.15,1.07-.51,2.34-1.1,3.81,1.57,1.87,2.81,3.53,3.74,5,.92,1.46,1.69,3.17,2.29,5.14.6,1.96.98,4.34,1.14,7.15.16,2.77.02,5.12-.44,7.06-.46,1.94-1.04,3.2-1.73,3.78-.77.65-2.03.59-3.79-.18-1.75-.77-3.45-2.12-5.09-4.07s-2.91-4.1-4.04-6.68c-1.13-2.59-2.42-6.06-3.89-10.42-2.07-.5-3.65-1.4-4.73-2.69-.88-1.05-1.29-2.06-1.24-3.05.05-.99.36-2.1.93-3.35-.25-1.71-.4-3.22-.44-4.53-.04-1.31-.08-3.07-.11-5.28-2.35-6.98-4.24-14.13-5.68-21.46-.4-2.04-.63-3.45-.7-4.21-.07-.76.08-1.3.46-1.62.34-.28.85-.27,1.54.02.69.3,1.38.86,2.06,1.68.84,1.01,1.52,2.02,2.01,3.03.5,1.02.91,2.11,1.24,3.29.33,1.18.65,2.64.97,4.41.32,1.76.52,2.85.6,3.27.53,2.64,1.09,5.57,1.69,8.82.6,3.24,1.07,5.8,1.41,7.68.35,1.88.63,3.27.85,4.17,1.88.07,3.42.19,4.63.37,1.21.18,2.44.55,3.71,1.14.45-.83.79-1.66,1.04-2.5.24-.83.47-1.89.68-3.17.21-1.28.44-2.49.68-3.64ZM152.71,193.43l-.6-.6c-.5.53-.93.91-1.3,1.17-.36.25-.83.49-1.39.72-.57.23-1.02.39-1.37.47-.35.08-.73.19-1.13.32,1.7,5.08,3.61,8.88,5.73,11.4,1.05,1.25,2.13,2.17,3.24,2.74,1.11.58,1.91.66,2.4.24s.77-1.45.75-3.05c-.01-1.6-.51-3.56-1.48-5.89-.98-2.33-2.59-4.84-4.85-7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,153.07l1.28-1.07c-.59-2.83-.8-5.01-.63-6.53.17-1.52.8-2.74,1.89-3.65s1.85-1.11,2.28-.6c.21.25.34,1.27.4,3.07.06,1.8.19,3.25.37,4.36.74-.48,1.4-.91,1.98-1.29.58-.38,1.03-.67,1.36-.88.7,3.12,1.15,6.53,1.36,10.24-.59.42-1.08.78-1.48,1.06-.4.28-.81.57-1.22.87s-.91.65-1.5,1.07c.43,2.68.87,5.03,1.33,7.04.46,2.01.98,3.76,1.58,5.26s1.33,2.76,2.21,3.81c1.19,1.42,2.33,1.67,3.41.76.75-.63,1.39-1.87,1.91-3.72s1.07-4.49,1.66-7.93l1.73,2.06c-.29,10.49-1.72,16.81-4.27,18.95-.89.75-1.91.99-3.05.73-1.15-.26-2.19-.96-3.14-2.09-.64-.76-1.24-1.79-1.81-3.09-.57-1.3-1.35-3.34-2.33-6.12-.07.48-.13.94-.18,1.38-.05.44-.1.85-.14,1.22-.04.37-.09.76-.15,1.18s-.11.83-.16,1.26l-1.78-2.12c.56-3.55.41-8.83-.45-15.83-.31.23-.6.45-.87.65-.27.21-.58.46-.93.76-1.17.98-1.97,1.79-2.4,2.44-.19.26-.35.51-.5.76-.15.25-.26.4-.34.47s-.17.04-.27-.09c-.57-.68-1.02-2.03-1.34-4.07-.31-1.7-.41-3.07-.29-4.11.12-1.04.52-2.01,1.19-2.92.68-.9,1.78-1.99,3.3-3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47,148.63l1.68,2c-.92,3.08-1.97,5.12-3.16,6.11-.65.55-1.44,1.02-2.36,1.4.18,3.83.09,6.83-.27,8.99-.36,2.16-1.19,3.78-2.47,4.85-1.48,1.24-3.31,1.39-5.47.44-2.16-.95-4.25-2.62-6.26-5.03-2.74-3.26-4.77-7.61-6.1-13.06-1.33-5.44-2.06-10.96-2.2-16.57-.14-5.6.13-10.56.8-14.86.67-4.3,1.45-6.83,2.34-7.57s1.78-.46,2.8.75c4.51,5.38,5.74,20.33,3.68,44.86.27.4.86,1.15,1.77,2.24,2.38,2.83,4.3,3.63,5.76,2.41.57-.48.95-1.21,1.13-2.18.18-.97.3-2.64.37-5.01-1.4-.71-2.33-1.33-2.78-1.87-.95-1.13-1.53-2.72-1.74-4.78-.21-2.06-.15-4.04.19-5.95.34-1.91.76-3.08,1.28-3.51.81-.68,1.72-.41,2.74.8.77.92,1.47,2.23,2.09,3.91.62,1.68,1.18,3.73,1.69,6.14.58,0,1.02,0,1.33-.04.31-.03.66-.21,1.06-.55.91-.76,1.61-2.07,2.11-3.93ZM170.53,156.65c.25-1.79.37-3.75.35-5.88s-.13-5.34-.32-9.62c-.18-4.11-.43-7.47-.73-10.06-.31-2.59-.65-4.68-1.02-6.25-.38-1.57-.74-2.56-1.08-2.97-.26-.31-.47-.4-.62-.26-.44.37-.72,1.87-.84,4.51-.13,2.64.02,5.99.43,10.06.56,5.61,1.06,9.78,1.49,12.5.43,2.72,1.21,5.38,2.36,7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.27,140.15c.63-5.35,1.78-9.9,3.45-13.65,1.67-3.75,3.28-6.27,4.82-7.56.42-.35.95-.49,1.61-.43.66.06,1.29.24,1.89.54.6.3,1,.56,1.19.79.31.37.4.76.27,1.16-.13.41-.44,1.02-.92,1.85.41.21.94.48,1.59.81.65.33,1.16.61,1.55.82.39.22.68.45.89.7.41.49.7,1.81.87,3.96.17,2.15.33,3.7.48,4.66.15.96.61,1.9,1.38,2.82,1.27,1.52,2.58,1.71,3.93.59s2.42-4.32,3.11-9.48l1.58,1.88c-.16,9.96-1.32,15.85-3.48,17.66-.77.65-1.54.85-2.3.6s-1.58-.89-2.44-1.91c-1.36-1.62-2.77-4.44-4.22-8.47-.1,5.75-.26,9.91-.48,12.5-.22,2.58-.79,4.26-1.7,5.02-.44.37-1.31.43-2.61.2-1.31-.23-2.73-.76-4.28-1.58-1.55-.82-2.88-1.89-4-3.23-.81-.96-1.4-1.84-1.76-2.64s-.57-1.75-.63-2.86c-.05-1.11.02-2.69.21-4.74ZM199.63,124.84c-3.09,6.76-5.02,11.9-5.77,15.44-.76,3.54-.38,6.21,1.14,8.01.55.66,1.11,1.1,1.68,1.34.57.24,1.04.2,1.42-.12.22-.18.48-.65.8-1.4,1.01-3.01,1.52-6.26,1.52-9.75,0-3.49-.26-7.99-.79-13.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.96,115.65l1.91,2.28c.64,9.15-.34,14.82-2.93,16.99-1.4,1.18-3.17,1.31-5.31.39-2.14-.92-4.29-2.67-6.46-5.26-1.76-2.09-3.37-4.98-4.84-8.66-1.47-3.68-2.65-7.67-3.55-11.97-.9-4.3-1.42-8.27-1.56-11.91-.14-3.64.15-6.52.87-8.63.28-.87.59-1.44.93-1.72.42-.35.85-.39,1.31-.13.46.26,1.07.86,1.85,1.78,2.39,2.85,4.22,7.29,5.47,13.32,1.25,6.03,1.7,12.89,1.34,20.57.7,1.23,1.29,2.14,1.77,2.71,1.1,1.31,2.27,2.15,3.5,2.52,1.23.36,2.33.14,3.3-.67.49-.41.86-1.06,1.1-1.94.24-.88.42-1.88.56-3.01.13-1.13.38-3.34.74-6.65ZM214.44,117.55c.15-1.91.14-3.93-.02-6.07-.16-2.14-.45-4.32-.88-6.56-.42-2.23-.9-4.16-1.43-5.77-.53-1.62-1.06-2.73-1.57-3.35-.4-.47-.75-.58-1.07-.31-.12.1-.25.4-.4.91-.35,2.04-.02,5.18.99,9.43,1,4.25,2.46,8.16,4.38,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,103.98l1.91,2.28c.64,9.15-.34,14.82-2.93,16.99-1.4,1.18-3.17,1.31-5.31.39-2.14-.92-4.29-2.67-6.46-5.26-1.76-2.09-3.37-4.98-4.84-8.66-1.47-3.68-2.65-7.67-3.55-11.97-.9-4.3-1.42-8.27-1.56-11.91-.14-3.64.15-6.52.87-8.63.28-.87.59-1.44.93-1.72.42-.35.85-.39,1.31-.13.46.26,1.07.86,1.85,1.78,2.39,2.85,4.22,7.29,5.47,13.32,1.25,6.03,1.7,12.89,1.34,20.57.7,1.23,1.29,2.14,1.77,2.71,1.1,1.31,2.27,2.15,3.5,2.52,1.23.36,2.33.14,3.3-.67.49-.41.86-1.06,1.1-1.94.24-.88.42-1.88.56-3.01.13-1.13.38-3.34.74-6.65ZM228.35,105.88c.15-1.91.14-3.93-.02-6.07-.16-2.14-.45-4.32-.88-6.56-.42-2.23-.9-4.16-1.43-5.77-.53-1.62-1.06-2.73-1.57-3.35-.4-.47-.75-.58-1.07-.31-.12.1-.25.4-.4.91-.35,2.04-.02,5.18.99,9.43,1,4.25,2.46,8.16,4.38,11.72Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftballLogo);
export default __webpack_public_path__ + "static/media/SoftballLogo.40d1415b0e4acf5065929979ed2a7d66.svg";
export { ForwardRef as ReactComponent };